<template>
    <div class="flex align-cen total">
        <!-- <img :src="businessInfo.logo || require('../../assets/images/blogo.png')" alt="" class="sider-head"> -->
        <div class="mft">
                <el-dropdown>
                <span class="el-dropdown-link flex align-cen" >
                <img :src="userinfo.avatar || require('../../assets/images/head.png')" alt="" class="info-head">
                 {{userinfo.name}} <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="switchHome"><i class="icon-al-home"></i> 返回官网</el-dropdown-item>
                    <el-dropdown-item @click.native="switchBuss"><i class="icon-al-switch"></i> 切换企业</el-dropdown-item>
                    <!-- <el-dropdown-item ><i class="icon-al-cog"></i> 个人设置</el-dropdown-item> -->
                    <el-dropdown-item   @click.native="logout1"><i class="icon-al-poweroff"></i>退出登录</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
        </div>
    </div>
</template>
<script>
import {enBusiness} from "@/api/enterprise/index" //查询企业列表
    export default {
        name:'index',
        props: {
            type: [String, Number], //接口返回的点名
        },
        data() {
            return {
                userinfo:{},
                title:'',
            }
        },
        computed: {
        },
        created() {
            // 获取本地存储用户信息
            this.userinfo = this.$locaStorage.setAge().get('userinfo1')
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        },
        mounted() {},
        watch: {},
        methods: {
            // 返回官网
            switchHome(){
                this.$router.push('/')
            },
            //切换企业
            switchBuss(){
          enBusiness({},'enterprise')
            .then(res =>{
                if(res.code == 0){
                 if(res.data.length == 1){
                   this.$util.Notifi('当前只有一个主体公司，无法切换！','error','fa-exclamation-circle');
                }else{
                this.$router.push('/webenterprise/enBusiness')
                }
                }
            })
            },
            close(){
                window.close()
            },
           logout1(){
             localStorage.removeItem('token1')
            localStorage.removeItem('userinfo1')
             localStorage.removeItem('businessInfo')
             this.$router.push('/webenterprise/homePage')
            },
        },
        components: { 

         },
         
        destroyed(){
            // this.$bus.$off('titname')
        }
    }
</script>

<style scoped lang="scss">
    .total{
        width: calc(100% - 210px);
          .sider-head{
            width: 120px;
            height: 40px;
        }
        .info-head{
            width: 30px;
            margin-right: 10px;
            height: 30px;
            border-radius: 50%;
        }
        .el-dropdown-link{
            color: #000;
            font-size: 16px;
            cursor: pointer;
        }
    }
</style>
